module.exports = __webpack_public_path__ + "static/cstoreslider-15-min-09ec2a4c8cd53ce28807b4a1d170d7c2.jpg";